import $api from '../services';
import dayjs from 'dayjs';

export default {
    moodData(params) {
        return $api.get('/session-votes', params);
    },
    votesData(params) {
        return $api.get('/session-votes', params);
    },
    dailyViewsData(params) {
        return $api.get('/session-votes/daily-view', params);
    },
    viewsData(params) {
        return $api.get('/session-votes/views', params);
    },
    countMeditatedUsers() {
        return $api.get('/profile/business/count-meditated-members');
    },
    totalMinutes(params) {
        return $api.get('/session-votes/total-minutes', params);
    },
    totalMinutesByGoal() {
        return $api.get('/session-votes/total-minutes-by-goal');
    },
    totalWatches(params) {
        return $api.get('/session-votes/total-watches', params);
    },
    totalWatchesByGoal() {
        return $api.get('/session-votes/total-watches-by-goal');
    },
    longestPractice() {
        return $api.get('/statistics/longest-practice');
    },
    dailyActivity(startDate, endDate) {
        const dateFrom = dayjs(startDate).format('YYYY-MM-DDT00:00:00[Z]');
        const dateTo = dayjs(endDate).format('YYYY-MM-DDT23:59:59[Z]');
        return $api.get('/system-events/view-page', { dateFrom, dateTo });
    }
};
